import React from 'react'
import { Link } from '@inertiajs/react'
import { useTranslation } from '@/hooks/useTranslation'
import styles from './Logo.module.scss'

export const Logo: React.FC = () => {
  const { lp } = useTranslation()

  return (
    <Link href={lp('/')} className={styles.logo}>
      <span className={styles.prompt} aria-hidden="true">~/</span>
      <span>codeofmario</span>
      <span className={styles.cursor} aria-hidden="true" />
    </Link>
  )
}
